import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { colors } from '@/theme/colors';
import theme from '@/theme';

interface ResourceLinkProps {
  href: string;
  title: string;
}

const ResourceLink: React.FC<ResourceLinkProps> = ({ href, title }) => {
  return (
    <Typography
      variant="body2"
      component="span"
      data-testid="resource-link-container"
    >
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: 'none' }}
        data-testid={`resource-link-${title.toLowerCase().replace(/\s+/g, '-')}`}
      >
        <Box
          component="span"
          data-testid="resource-link-text"
          sx={{
            color:
              theme.palette.mode === 'dark'
                ? colors.royal80
                : theme.palette.secondary.main,
            textDecoration: 'underline',
            fontWeight: 500,
            transition: 'color 0.2s ease',
            '&:hover': {
              color:
                theme.palette.mode === 'dark' ? colors.blue400 : colors.royal80,
            },
          }}
        >
          {title}
        </Box>
      </a>
    </Typography>
  );
};

export default ResourceLink;
